import { Container } from "reactstrap";
import { ExclusiveFeaturesTitle, FeaturesText } from "../../Constants/Constants";
import { dynamicImage, Image } from "../../Utils";

const ExclusiveFeature = () => {
  return (
    <section className="section-py-space client-messenger-box">
      <div className="custom-container">
        <div className="content-title">
          <h3>{ExclusiveFeaturesTitle}</h3>
          <h2>{FeaturesText}</h2>
          <span />
        </div>
      </div>
      <Container fluid>
        <div className="client-images">
          <Image src={dynamicImage("index/client.png")} alt="App_Design" />
          <Image src={dynamicImage("index/client.png")} alt="App_Design" />
          <Image src={dynamicImage("index/client.png")} alt="App_Design" />
        </div>
      </Container>
    </section>
  );
};

export default ExclusiveFeature;
